const search = {
  name: "名称",
  account: "账号",
  imei:"imei",
  terminalAccount:"终端账号",
  terminalName:"终端名称",
  status: "状态",
  phone: "手机号",
  group: "群组",
  proxy: "代理",
  enterprise: "企业",
  subagent: "子代理",
  proxyAnbSubagent:'代理/子代理',
  secondaryManagement: "二级管理",
  onlinestatus: "在线状态",
  createTime: "创建日期",
  enableTime: "开始时间",
  maturityTime: "到期时间",
  modifyTime: "修改时间",
  domainName: "域名",
  logEventType: "日志类型",
  operatorAccount: "操作者账号",
  originAccount: "来源账号",
  targetAccount: "目标账号",
  targetAccount_1:'被操作人账号',
  orderType: '订单类型',
  orderId:'订单Id',






};

export default search;



// WEBPACK FOOTER //
// ./src/api/lang/modules/search/search_zh.js